/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthProResponse
 */
export interface HealthProResponse {
    /**
     * the unique identifier of medical person
     * @type {string}
     * @memberof HealthProResponse
     */
    id?: string;
    /**
     * the firstname of medical person
     * @type {string}
     * @memberof HealthProResponse
     */
    firstName?: string;
    /**
     * the lastname of medical person
     * @type {string}
     * @memberof HealthProResponse
     */
    lastName?: string;
    /**
     * the license number of the health pro
     * @type {string}
     * @memberof HealthProResponse
     */
    misaNumber?: string;
}

/**
 * Check if a given object implements the HealthProResponse interface.
 */
export function instanceOfHealthProResponse(value: object): value is HealthProResponse {
    return true;
}

export function HealthProResponseFromJSON(json: any): HealthProResponse {
    return HealthProResponseFromJSONTyped(json, false);
}

export function HealthProResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthProResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'misaNumber': json['misaNumber'] == null ? undefined : json['misaNumber'],
    };
}

export function HealthProResponseToJSON(json: any): HealthProResponse {
    return HealthProResponseToJSONTyped(json, false);
}

export function HealthProResponseToJSONTyped(value?: HealthProResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'misaNumber': value['misaNumber'],
    };
}

